export const environment = {
  production: false,
  apiBaseUrl: 'https://apibaker.hakunamatatatech.io',
  googleMapsApiKey: 'AIzaSyAIW2z9e7hk_LPcKoVd55K7pMcbMiXuUv4',

};

